import React, { Component } from 'react';
import DatasetFilter from '../commonComponents/DatasetFilter';
import GeneralSettings from './GeneralSettings';
// import DefaultSelection from './DefaultSelection';


export default class SettingParent extends Component{

    constructor(props){
        super(props);

    }

    render(){

        return(
            <div id="main-content">
                <div className="" style={{width:"255px"}}>
                    <DatasetFilter />
                </div>
                <GeneralSettings datasetValue={this.props.datasetValue} authData={this.props.authData} />
                {/* <TabComponent headers={tab_headers} body={tab_body}/> */}
            </div>
        )
    }
}